import stylesColors from 'common/styles/styles.colors';
import * as React from 'react';
import RawSwitch, { ReactSwitchProps } from 'react-switch';

export interface SwitchProps extends ReactSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const Switch = React.forwardRef<RawSwitch, SwitchProps>((props, ref) => {
  return (
    <RawSwitch
      {...props}
      ref={ref}
      checked={props.checked}
      onChange={props.onChange}
      onColor={stylesColors.primaryLightest}
      offColor={stylesColors.skyLight}
      onHandleColor={stylesColors.primaryDefault}
      handleDiameter={24}
      uncheckedIcon={false}
      checkedIcon={false}
      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
      height={16}
      width={48}
      disabled={props.disabled}
    />
  );
});

Switch.displayName = 'Switch';

export default Switch;
